export const Loading = () => {
  return <span className="loader"></span>
}
